import { isJust, isNothing, type Maybe, toMaybe } from "./maybe";
// Barrel — re-exports the split `zwConfig/*` modules so existing imports of
// `"../lib/zwConfig"` (or relative equivalents) keep working unchanged.
export * from "./zwConfig/types";
export * from "./zwConfig/defaults";
export * from "./zwConfig/normalize";
export * from "./zwConfig/scenes";
export * from "./zwConfig/manuscript";

import type { ZwConfig } from "./zwConfig/types";

/** Display title: metadata title, else folder/fallback name. */
export function projectDisplayName(
  config: Maybe<ZwConfig>,
  fallback: string,
): string {
  if (isNothing(config)) return fallback;
  const titleM = toMaybe(config.value.metadata.title?.trim());
  return isJust(titleM) && titleM.value !== "" ? titleM.value : fallback;
}
